import { useTaskListPage } from '@app/pages/TasksList/hooks';

export const TasksListPage = () => {
  const { TabComponent } = useTaskListPage();

  return <TabComponent />;
};
